import type { AuthService } from "@domain/port/AuthService";
import { HttpClient } from "@infra/HttpClient";
import type {
  LoginRequest,
  SignupRequest,
  SignupResponse,
  TokenBundle,
} from "@/domain/model/Auth";

export class AuthServiceImpl implements AuthService {
  constructor(private readonly http: HttpClient) {}

  signup(req: SignupRequest) {
    return this.http.request<SignupResponse>(
      "/api/signup",
      {
        method: "POST",
        body: JSON.stringify(req),
      },
      "none",
    );
  }

  login(req: LoginRequest) {
    return this.http.request<TokenBundle>(
      "/api/login",
      {
        method: "POST",
        body: JSON.stringify(req),
      },
      "none",
    );
  }

  async logout(): Promise<void> {
    return this.http.request<void>(
      "/api/logout",
      {
        method: "POST"
      }
    );
  }
}
